var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require :
typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});

// src/async-context.ts
var NoOpStorage = class {
  static {
    __name(this, "NoOpStorage");
  }
  getStore() {
    return void 0;
  }
  run(_context, fn) {
    return fn();
  }
  enterWith(_context) {
  }
};
var AsyncLocalStorageClass;
try {
  const asyncHooks = __require("async_hooks");
  AsyncLocalStorageClass = asyncHooks.AsyncLocalStorage;
} catch {
  AsyncLocalStorageClass = void 0;
}
function createStorage() {
  if (AsyncLocalStorageClass) {
    return new AsyncLocalStorageClass();
  }
  return new NoOpStorage();
}
__name(createStorage, "createStorage");
var requestContextStorage = createStorage();
var transactionContextStorage = createStorage();
function getRequestContext() {
  return requestContextStorage.getStore();
}
__name(getRequestContext, "getRequestContext");
function getTransactionContext() {
  return transactionContextStorage.getStore();
}
__name(getTransactionContext, "getTransactionContext");
function getMergedContext() {
  const requestCtx = getRequestContext() ?? {};
  const transactionCtx = getTransactionContext() ?? {};
  return { ...requestCtx, ...transactionCtx };
}
__name(getMergedContext, "getMergedContext");
async function runWithRequestContext(context, fn) {
  return requestContextStorage.run(context, fn);
}
__name(runWithRequestContext, "runWithRequestContext");
function runWithRequestContextSync(context, fn) {
  return requestContextStorage.run(context, fn);
}
__name(runWithRequestContextSync, "runWithRequestContextSync");
async function runWithTransactionContext(context, fn) {
  return transactionContextStorage.run(context, fn);
}
__name(runWithTransactionContext, "runWithTransactionContext");
function runWithTransactionContextSync(context, fn) {
  return transactionContextStorage.run(context, fn);
}
__name(runWithTransactionContextSync, "runWithTransactionContextSync");
async function runWithMergedContext(requestCtx, transactionCtx, fn) {
  return requestContextStorage.run(
    requestCtx,
    () => transactionContextStorage.run(transactionCtx, fn)
  );
}
__name(runWithMergedContext, "runWithMergedContext");
async function extendRequestContext(additionalContext, fn) {
  const currentContext = getRequestContext() ?? {};
  const mergedContext = { ...currentContext, ...additionalContext };
  return requestContextStorage.run(mergedContext, fn);
}
__name(extendRequestContext, "extendRequestContext");
async function extendTransactionContext(additionalContext, fn) {
  const currentContext = getTransactionContext() ?? {};
  const mergedContext = { ...currentContext, ...additionalContext };
  return transactionContextStorage.run(mergedContext, fn);
}
__name(extendTransactionContext, "extendTransactionContext");
function hasRequestContext() {
  return requestContextStorage.getStore() !== void 0;
}
__name(hasRequestContext, "hasRequestContext");
function hasTransactionContext() {
  return transactionContextStorage.getStore() !== void 0;
}
__name(hasTransactionContext, "hasTransactionContext");
function clearRequestContext() {
  requestContextStorage.enterWith({});
}
__name(clearRequestContext, "clearRequestContext");
function clearTransactionContext() {
  transactionContextStorage.enterWith({});
}
__name(clearTransactionContext, "clearTransactionContext");
export {
  clearRequestContext,
  clearTransactionContext,
  extendRequestContext,
  extendTransactionContext,
  getMergedContext,
  getRequestContext,
  getTransactionContext,
  hasRequestContext,
  hasTransactionContext,
  runWithMergedContext,
  runWithRequestContext,
  runWithRequestContextSync,
  runWithTransactionContext,
  runWithTransactionContextSync
};
